module.exports = __webpack_public_path__ + "img/icon-check.f500be45.svg";